import axios from 'axios';

let cache = {};

export const clearRequestCache = () => {
  cache = {};
};
export const cancellable = <T>(
  request: any,
  dataTransform: (data: any, headers: any) => T,
  cacheKey?: string
) => {
  const cancel = axios.CancelToken;
  const source = cancel.source();

  return {
    getData: async (): Promise<T> => {
      if (cacheKey && cache[cacheKey]) {
        return cache[cacheKey];
      }

      const response = await request({
        cancelToken: source.token,
      });
      if (!response) {
        throw Error();
      }
      const data = dataTransform(response.data, response.headers);

      if (cacheKey) {
        cache[cacheKey] = data;
      }
      return data;
    },
    updateCache: (data: T) => {
      if (!cacheKey) {
        return;
      }
      cache[cacheKey] = data;
    },
    cancel: source.cancel,
  };
};



// WEBPACK FOOTER //
// ./src/services/api/cancellable.ts